import Checkbox from "@mui/material/Checkbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import React from "react";
import { StyledCustomList } from "../../styled/list";

export const customListLeft = (items, checked, leftChecked, handleToggle) => {
  items.sort((a, b) => a.nombre.localeCompare(b.nombre));

  return (
    <StyledCustomList.StyledPaper>
      <List dense component="div" role="list">
        {items.length === 0
          ? null
          : items.map((value) => {
              const labelId = `transfer-list-item-${value.id}-label`;
              return (
                <ListItem
                  key={value.id}
                  role="listitem"
                  button
                  onClick={handleToggle(value)}>
                  <StyledCustomList.ListItemIconContainer>
                    <ListItemIcon>
                      <Checkbox
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple={true}
                        disabled={leftChecked.length !== 1}
                        inputProps={{ "aria-labelledby": labelId }}
                      />
                    </ListItemIcon>
                    <StyledCustomList.Text variant="body1">
                      {value.nombre}
                    </StyledCustomList.Text>
                  </StyledCustomList.ListItemIconContainer>
                </ListItem>
              );
            })}
      </List>
    </StyledCustomList.StyledPaper>
  );
};

export const customListRight = (items) => {
  items.sort((a, b) => a.nombre.localeCompare(b.nombre));

  return (
    <StyledCustomList.StyledPaper>
      <List dense component="div" role="list">
        {items.length === 0
          ? null
          : items.map((value) => {
              return (
                <ListItem key={value.id} role="listitem" button>
                  {value.adherida === 0 ? (
                    <div>
                      <b>
                        <StyledCustomList.Text variant="body1">
                          {value.nombre}
                        </StyledCustomList.Text>
                      </b>
                      <StyledCustomList.TextStatus color="ForestGreen">
                        Adherida
                      </StyledCustomList.TextStatus>
                    </div>
                  ) : (
                    <div>
                      <StyledCustomList.Text variant="body1">
                        {value.nombre}
                      </StyledCustomList.Text>
                      <StyledCustomList.TextStatus color="Highlight">
                        Pendiente
                      </StyledCustomList.TextStatus>
                    </div>
                  )}
                </ListItem>
              );
            })}
        <ListItem />
      </List>
    </StyledCustomList.StyledPaper>
  );
};
